<template>
    <v-container class="pa-0">
        <v-card>
            <v-container>
                <div
                    class="d-flex justify-space-between flex-wrap flex-md-nowrap"
                >
                    <div class="d-flex flex-column">
                        <div class="d-flex align-center">
                            <div class="overline"><TranslatableStringComponent :tstring="{string: 'label'}" /></div>
                            <v-btn
                                icon
                                x-small
                                color="primary"
                                :loading="updateCartLoader"
                                @click="showDialog"
                                ><fa
                                    :icon="['fal', 'pen']"
                                    class="fa-sm"
                                    style="color: #0063a6"
                            /></v-btn>
                        </div>
                        <div>{{ label ? label : '--' }}</div>
                    </div>
                    <p class="d-flex flex-column">
                        <span class="overline"><TranslatableStringComponent :tstring="{string: 'savedOn'}" />:</span>
                        <span>{{ convertToReadabledate(cart.createdAt) }}</span>
                    </p>
                    <p class="d-flex flex-column">
                        <span class="overline"><TranslatableStringComponent :tstring="{string: 'lastUpdated'}" />:</span>
                        <span>{{ convertToReadabledate(cart.updatedAt) }}</span>
                    </p>
                    <p class="d-flex flex-column">
                        <span class="overline"><TranslatableStringComponent :tstring="{string: 'subtotal'}" />:</span>
                        <span>{{ dollars(cart.subtotal) }}</span>
                    </p>
                    <p class="d-flex flex-column">
                        <span class="overline"><TranslatableStringComponent :tstring="{string: 'pricelistApplied'}" />:</span>
                        <span>{{ cart.PriceList.name }}</span>
                    </p>
                </div>
                <div class="d-flex justify-end">
                    <div
                        class="d-flex justify-space-between flex-wrap flex-md-nowrap"
                    >
                        <v-btn
                            text
                            small
                            color="primary"
                            :loading="deleteCartLoader"
                            @click="deleteSavedcart()"
                            ><TranslatableStringComponent :tstring="{string: 'delete'}" /></v-btn
                        >
                        <v-btn
                            text
                            small
                            color="primary"
                            class="ml-2"
                            @click="handleClipboard()"
                            ><TranslatableStringComponent :tstring="{string: 'shareableCartLink'}" />
                            <fa :icon="['fal', 'link']" class="fa-sm ml-1"
                        /></v-btn>
                        <v-btn
                            small
                            color="primary"
                            class="ml-2"
                            @click="toggleCartItems"
                            >{{ show ? 'Hide cart Items' : 'Show Cart Items' }}
                            <fa
                                :icon="[
                                    'fal',
                                    `${show ? 'chevron-up' : 'chevron-down'}`,
                                ]"
                                class="fa-sm ml-1"
                                style="color:#fff   "
                        /></v-btn>
                        <v-btn
                            text
                            small
                            outlined
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'cart',
                                    query: { savedcartId: cart.id },
                                })
                            "
                            color="primary"
                            class="ml-2"
                            ><TranslatableStringComponent :tstring="{string: 'continueOrder'}" />
                            <fa
                                :icon="['fal', 'shopping-cart']"
                                class="fa-sm ml-1"
                        /></v-btn>
                    </div>
                </div>
            </v-container>
            <v-expand-transition>
                <div v-show="show">
                    <v-divider class="mb-3"></v-divider>
                    <div v-for="i in cartItems" :key="i.pn" class="pb-3 px-3">
                        <CardSingleSKUMobile
                            v-if="$vuetify.breakpoint.smAndDown"
                            :item="i"
                            img-crop="fill"
                            :is-saved-cart-item="true"
                        />
                        <CardSingleSKU
                            v-else
                            :item="i"
                            :key="`${i.pn}${componentKey}`"
                            img-crop="fill"
                            :is-saved-cart-item="true"
                        />
                    </div>
                </div>
            </v-expand-transition>
        </v-card>
        <LabelSavedCartDialog
            :showSavedCardLabelForm="showSavedCardLabelForm"
            :label="label"
            @saveLabel="saveLabel"
            @closeDialog="showSavedCardLabelForm = false"
        />
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import CardSingleSKU from '~/components/cards/CardSingleSKU.vue'
import CardSingleSKUMobile from '~/components/cards/CardSingleSKUMobile.vue'
import LabelSavedCartDialog from '~/components/LabelSavedCartDialog.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
import handleSnackbar from '~/mixins/handleSnackbar'
export default {
    name: 'SavedCartsSingle',
    components: {
        CardSingleSKU,
        CardSingleSKUMobile,
        LabelSavedCartDialog,
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar],
    props: {
        cart: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            show: false,
            deleteCartLoader: false,
            showSavedCardLabelForm: false,
            label: '',
            updateCartLoader: false,
            componentKey: 0,
        }
    },
    computed: {
        ...mapState('savedCarts', [
            'savedCartLabel',
        ]),
        ...mapGetters({
            fetchCartProducts: 'cart/fetchCartProducts',}),
        cartItems() {
            return this.cart.itemData.map((item) => {
                return {
                    pn: item.pn,
                    prod_quantity: item.qty,
                    img: item.img,
                    list_price: item.listPrice,
                    subTotalListPrice: item.listPrice * item.qty,
                    sale_price: item.yourPrice,
                    subTotalSalePrice: item.yourPrice * item.qty,
                    quantityInCart: this.fetchCartProducts.find(
                    (cartItem) => cartItem.pn === item.pn
                )?.prod_quantity || 0
                }
            })
        },
        shareableLink() {
            return `${process.env.V2_BASE_URL}/cart?savedcartId=${this.cart.id}`
        },
    },
    mounted(){
        this.label = this.cart.label
    },
    methods: {
        convertToReadabledate(isoDate) {
            return isoDate
                ? new Intl.DateTimeFormat('en-US').format(new Date(isoDate))
                : ''
        },
        handleClipboard() {
            navigator.clipboard.writeText(this.shareableLink)
            this.hitSnackbar({ string: 'linkCopiedSuccessfully'}, null)
        },
        async deleteSavedcart() {
            this.deleteCartLoader = true
            await this.$store.dispatch(
                'savedCarts/deleteSavedCart',
                this.cart.id
            )
            this.deleteCartLoader = false
            this.$emit('refreshSavedCart')
        },
        showDialog() {
            this.showSavedCardLabelForm = true
        },
        saveLabel(label) {
            this.updateSavedCart(label)
        },
        toggleCartItems() {
            this.show = !this.show
            this.componentKey++
            if(this.show)
                this.$store.commit('priceList/setSelectedPriceListId', this.cart.PriceListId)
        },
        async updateSavedCart(label) {
            this.showSavedCardLabelForm = false
            this.updateCartLoader = true
            const payload = {
                label,
                id: this.cart.id,
                cartItems: this.cartItems.map(item => {
                    return{
                    pn: item.pn,
                    qty: item.prod_quantity,
                    listPrice: item.list_price,
                    yourPrice: item.sale_price,
                    img: item.img,}
                }),
                subTotal: this.cart.subtotal,
            }
            await this.$store.dispatch('savedCarts/updateSavedCart', payload)

            this.updateCartLoader = false
            this.label = this.savedCartLabel
        },
    },
}
</script>
